var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.signedOutText),expression:"signedOutText"}],staticClass:"disabled-comment gl-text-center gl-text-secondary"})
}
var staticRenderFns = []

export { render, staticRenderFns }